import styled from 'styled-components';
import { Link } from '../../../../../../common/components/Link';
import { HeColours } from '../../../../../../common/styles/HeColours';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import {
  Breakpoint,
  FontWeight,
  FONT_STACK,
  PRESSABLE,
} from '../../../../../../common/styles/constants';
import { onMobile } from '../../../../../../common/styles/onMobile';

export const AppointmentsView = styled.div`
  ${FONT_STACK};
  align-items: center;
  background-color: ${HeColours.gray[50]};
  display: flex;
  flex-direction: row;
  height: 48px;
  justify-content: flex-end;
  overflow: hidden;

  ${onMobile} {
    height: auto;
    min-height: 48px;
  }
`;

export const Content = styled.div`
  color: ${ThemeColours.mono700};
  flex-grow: 1;
  font-size: 14px;
  line-height: 1.15em;
  margin: 4px 0 4px 16px;

  ${Breakpoint.MEDIUM} {
    color: ${ThemeColours.mono700};
    font-size: 12px;
    font-weight: ${FontWeight.REGULAR};
    margin: 4px 0 4px 24px;
  }
`;

export const CtaLink = styled(Link)`
  ${PRESSABLE};
  align-items: center;
  align-self: stretch;
  background-color: ${ThemeColours.buttonPrimaryFill};
  border: none;
  border-radius: 16px;
  box-sizing: border-box;
  color: ${ThemeColours.buttonPrimaryText};
  display: flex;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 1em;
  margin: 0 24px 0 8px;
  padding: 9px 16px;
  text-align: center;
  text-decoration: none;

  ${Breakpoint.MEDIUM} {
    align-self: center;
    font-weight: ${FontWeight.BOLD};
  }
`;

export const CallPracticeLink = styled(CtaLink)`
  background-color: ${ThemeColours.white};
  border: solid 1px ${ThemeColours.primary};
  color: ${ThemeColours.primary};

  ${onMobile} {
    box-shadow: -1px 0 4px 0 rgba(0, 0, 0, 0.15);
  }
`;

export const CallToAction = styled.div`
  ${PRESSABLE};
`;

export const AppointmentInfo = styled.div`
  color: ${ThemeColours.black};
  flex-grow: 1;
  font-size: 12px;
  font-weight: ${FontWeight.REGULAR};
  line-height: 1.15em;
  margin: 4px 0 4px 24px;

  ${onMobile} {
    color: ${ThemeColours.mono700};
    flex-direction: column;
    font-size: 14px;
    margin: 4px 0 4px 8px;
  }
`;

export const PhoneNumber = styled.span`
  font-weight: ${FontWeight.SEMI_BOLD};
`;
